export function decodeRichAssetContentLocation(richAssetContent) {
  return richAssetContent;
}

export function encodeRichAssetContentLocation(richAssetContent) {
  return richAssetContent;
}

export function validateRichAssetContentLocation(
  richAssetContent,
  touched_rich_asset_content,
  validateOnlyTouched
) {
  let errors = {};
  let foundError = false;
  if (
    !richAssetContent &&
    (!validateOnlyTouched ||
      (validateOnlyTouched && touched_rich_asset_content))
  ) {
    errors = "A message is required";
    foundError = true;
  }
  return foundError ? errors : undefined;
}
